import * as yup from 'yup';
export const UpdateTeamSchema = yup.object().shape({
  teamName: yup.string().required('Required!'),
  // school: yup.string().required('Required'),
  // status: yup.string().required('Required'),
  // teamMembers: yup.string().required('Required'),
});
